import {atom} from "jotai";

export const updateWorkLogStateAtom = atom(false);
export const updateWorkLogDataAtom = atom({});